const urlJoin = require('url-join');

const path = require('path');
import Avatars from "./avatars";
import { breakpoints } from "./responsive_utilities";
import WEB_HELPER_DATA from './web-helper.json';
import * as Sentry from "@sentry/react";

import Avo from './avo/avo';
import AvoDestination from './avo/avo-destination';

import React from "react";
import { createStore } from "redux";
import { Provider } from "react-redux";
import { AssignAbTests } from "../services/parent-api";
import { loadStripe } from '@stripe/stripe-js';
import { getABTestValue } from "./ab-tests";
import { canPlayHelperUtility } from './can-play-helper/canPlayHelper';
import { CheckUserCanPlayPlayzoneGame } from "../services/student-api";

import { gradeMappingForCompare, SECOND_GRADE, THIRD_GRADE, FOURTH_GRADE, FIVE_GRADE, SHOW_POPUP, FREEMIUM_NO_BLOCKER_TIME_IN_MINUTE, ACTIVE_TAB_CODE_KEY, WORKSHEET, TAB_CODE, LIVE_CLASS, OldPurchasePagePlanCodes, UNLIMITED } from "../constant-data/constants";
import i18n from "./i18n";
import { TypesOfModes } from "../components/gamification/header-banner/typeOfModes";
import { cityCountryCodeMapping } from "../constant-data/constants";
import { hasAccessToFlutterDRS, hasAccessToFreemium, hasAccessToTeacherFreemiumNoBlocker, isFreemiumDRSAssigned, isGameHeaderV1Assigned, toShowStripePaymentElement, toShowStripePaymentElementWithPaypal } from "./feature_mapping";
import { useMediaQuery } from 'react-responsive';
import { Store } from "../stores/student-dashboard";
import { PURCHASE_PATH } from "../flutter-integration/messaging/hash_path";
import { getHostName } from "../constant-data/urls";
import ApplicationContext from "../flutter-integration/ApplicationContext";
import { tabNames } from "../flutter-integration/constants";
import * as _ from 'lodash';
import { fetchAvatarUrl } from "../services/graphql-freemium-api";
import { Store as ParentStore} from '../stores/parent-dashboard';

export function assetPath(relativePath) {
  if (!relativePath)
    return ""

  var manifestPath;
  let url;
  if (!!window.UI_MANIFEST_JSON) {
    manifestPath = UI_MANIFEST_JSON[relativePath] || relativePath;
  } else {
    manifestPath = relativePath;
  }
  if (window.location.hostname === 'localhost') {
    url = urlJoin(path.join('', manifestPath));
  }
  else {
    url = manifestPath;
  }
  return url;
}

export function avatarUrl(code) {
  return assetPath(Avatars[code]);
}

export function playableImage(code, curriculumCode) {
  var folderPath = curriculumCode && ['uk', 'aus'].includes(curriculumCode) ? `curriculum_uploads/images/${curriculumCode}/playables` : "curriculum_uploads/images/playables";
  var imageName = code?.replace(/[\W_]+/g, "_") + '.png';
  var cdnHost = window.DEV_STAGING_CDN || window.UI_ASSET_HOST;
  return urlJoin(cdnHost, folderPath, imageName)
}

export function gameImage(code) {
  var folderPath = "curriculum_uploads/images/games";
  var imageName = code.replace(/[\W_]+/g, "_") + '.png';
  var cdnHost = window.DEV_STAGING_CDN || window.UI_ASSET_HOST;
  return urlJoin(cdnHost, folderPath, imageName)
}

export function onboardingQuestionsImage(params) {
  const { subject, grade, code } = params;
  const folderPath = `web_ui/assets/images/parent-onboarding-questions/${subject[0].toUpperCase() + subject.slice(1)}_svg/${grade}/`;
  const imageName = code + '.svg';
  const cdnHost = window.DEV_STAGING_CDN || window.UI_ASSET_HOST;
  return urlJoin(cdnHost, folderPath, imageName);
}

export function gamificationTileImages(params) {
  const { subject, grade, code, imageSize } = params;
  const folderPath = `assets/gamification-tile-images/${subject}/${grade}/${code}/`
  const imageName = imageSize + '.' + (params.imageType || 'svg');
  const cdnHost = window.DEV_STAGING_CDN || window.UI_ASSET_HOST;
  return urlJoin(cdnHost, folderPath, imageName);
}

export function gamificationSounds(fileName, dir = null) {
  const folderPath = dir ? `assets/gamification-sounds/${dir}` : `assets/gamification-sounds/`;
  const imageName = fileName + '.mp3';
  const cdnHost = window.DEV_STAGING_CDN || window.UI_ASSET_HOST;
  return urlJoin(cdnHost, folderPath, imageName);
}

export function onboardingQuestionsAudio(code) {
  const folderPath = `web_assets/sounds/parent-onboarding-questions`;
  const audioName = code;
  const cdnHost = window.DEV_STAGING_CDN || window.UI_ASSET_HOST;
  return urlJoin(cdnHost, folderPath, audioName);
}

export function isIOS() {
  const ua = window.navigator.userAgent;
  if (ua.indexOf('Macintosh') > -1) {
    try {
      document.createEvent("TouchEvent");
      return true;
    } catch (e) { }
  }
  else {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  }
  return false;
}

export function isAndroid() {
  return /Android/.test(window.navigator.userAgent);
}

export function isIosOrAndroid() {
  return isIOS() || isAndroid();
}

export function isIOSorMacDevice() {
  return /iPad|iPhone|iPod/.test(navigator.platform) ||
    navigator.userAgent.indexOf('Mac') > -1 ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}

export function isIpadDevice() {
  const ua = window.navigator.userAgent;

  if (ua.indexOf('iPad') > -1) {
    return true;
  }

  else if (ua.indexOf('Macintosh') > -1) {
    return navigator.maxTouchPoints &&
      navigator.maxTouchPoints > 2 &&
      /MacIntel/.test(navigator.platform);
  }

  return false;
}

export function returnDevice() {
  let device = "web"
  if (isIpadDevice()) {
    device = "iPad"
  }
  if (isIOS() && isMobileDevice()) {
    device = "iPhone"
  }
  return device
}

export function isMobileDevice() {
  return window.innerWidth <= breakpoints.sm || (window.innerWidth > window.innerHeight && window.innerWidth > breakpoints.sm && window.innerWidth < breakpoints.lg);
}

export function isTabletDevice() {
  const userAgent = navigator.userAgent.toLowerCase();
  const innerWidth = window.innerWidth;
  const innerHeight = window.innerHeight;
  const isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent) || isIpadDevice() || (innerWidth >= breakpoints.md && innerWidth <= 1024 || ((innerWidth > innerHeight) && (innerWidth >= breakpoints.md) && innerWidth < breakpoints.xl));
  return isTablet;
}

export function isIE() {
  var ua = window.navigator.userAgent;
  var isIE = /MSIE|Trident/.test(ua);
  if (isIE) {
    return true;
  }
  else {
    return false;
  }
}

export function handleEscPressOnPopup(event, handler) {
  if (event.which && event.which === 27) {
    handler();
  }
}
export function isFreeCardsLeftToPlay(cardsCompletedCount, freeCardsLimit) {

  if (cardsCompletedCount < freeCardsLimit) {
    return true
  }
  else {
    return false;
  }
}
export function freeCardsExhaustedEvent(currentCourse, cardsCompletedCount) {
  let eventBody = '';
  if (currentCourse && currentCourse.subject_code === 'math')
    eventBody = { 'Math cards played': cardsCompletedCount }
  else
    eventBody = { 'Reading cards played': cardsCompletedCount }
  trackAnalyticsEvent('Free Cards Exhausted', eventBody, true)
}

export function getUrlObj(url) {
  if (!(url && (url.startsWith('http://') || url.startsWith('https://')))) {
    return null;
  }
  const urlArr = (url.split('?')[0]).split('#');
  const urlArr1 = urlArr[0].split('//');
  const hash = urlArr[1];
  const protocol = urlArr1[0];
  const [host, pathname] = urlArr1[1].split('/');
  return {
    hash: '#' + hash,
    protocol,
    href: url,
    host,
    pathname: '/' + pathname,
    origin: protocol + '//' + host
  };
}

export function performDashboardBackTrace(e, studentId = '', subject = '') {
  const dashboardMathArr = WEB_HELPER_DATA.DASHBOARD_BACK_TRACE.DASHBOARD_MATH_URL_ARR;
  const dashboardElaArr = WEB_HELPER_DATA.DASHBOARD_BACK_TRACE.DASHBOARD_ELA_URL_ARR;
  const dashboardArr = [...dashboardMathArr, ...dashboardElaArr];
  const prevLocationObj = WEB_HELPER_DATA.DASHBOARD_BACK_TRACE.PREV_LOCATION_URLS;
  dashboardArr.forEach(el => {
    const newUrl = getUrlObj(e.newURL);
    if ((newUrl.pathname + newUrl.hash) === el) {
      const oldUrl = getUrlObj(e.oldURL);
      // Check for dashboard redirection from dashboard
      if (!oldUrl.hash || (
        oldUrl.hash !== '#/reading' &&
        oldUrl.hash !== '#/math' &&
        dashboardArr.includes(oldUrl.pathname + oldUrl.hash)
      )
      ) {
        return null;
      }

      // Formal some dynamic Old URLs
      oldUrl.hash = (studentId && oldUrl.hash.includes(`/${studentId}/`)) ? oldUrl.hash.replace(studentId, ':studentId') : oldUrl.hash;
      oldUrl.hash = !dashboardElaArr.includes(newUrl.pathname + newUrl.hash) && oldUrl.hash.includes('#/topic/') ?
        '#/topic/' :
        oldUrl.hash;

      // Trigger Event if after finding suitable previous location
      const prevLocation = prevLocationObj[oldUrl.pathname + oldUrl.hash] || 'Others';
      trackAnalyticsEvent('Viewed Dashboard', {
        'Last Visited Screen': prevLocation,
        'Subject': (!!subject ? ((subject === 'math') ? 'Math' : 'Reading') : '')
      });
    }
  });
}

export function isMobileOrIpad() {
  let check = false;
  (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
}

export function playableCloseEvent(learning_objective_id, learningObjectiveMap, contentGroupMap, milestoneMap, from = "", code) {
  const eventObj = {};
  const loObj = learningObjectiveMap && learningObjectiveMap.get(learning_objective_id);
  const cgId = loObj && loObj.content_group_id;
  const milestoneId = loObj && loObj.milestone_id;
  eventObj['LO'] = loObj && loObj.code || code;
  eventObj['Content Group'] = contentGroupMap && contentGroupMap.get(cgId) && contentGroupMap.get(cgId)['code'];
  eventObj['Milestone'] = milestoneMap && milestoneMap.get(milestoneId) && milestoneMap && milestoneMap.get(milestoneId)['code'];
  from && (eventObj['From'] = from);
  trackAnalyticsEvent('IFrame Closed', { ...eventObj });
}

export const elaSignupFlow = true;

export const REGEX_COLLECTION = {
  EMAIL_REGEX: /^[a-zA-Z0-9!#\$%&'\*\+\/=\?\^_`\{\|}~-]+(\.[a-zA-Z0-9!#\$%&'\*\+\/=\?\^_`\{\|}~-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.([a-zA-Z]{2,})$/
};

export function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this, args = arguments;
    var later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};
export function throttle(func, wait, options) {
  var context, args, result;
  var timeout = null;
  var previous = 0;
  if (!options) options = {};
  var later = function () {
    previous = options.leading === false ? 0 : Date.now();
    timeout = null;
    result = func.apply(context, args);
    if (!timeout) context = args = null;
  };
  return function () {
    var now = Date.now();
    if (!previous && options.leading === false) previous = now;
    var remaining = wait - (now - previous);
    context = this;
    args = arguments;
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      previous = now;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining);
    }
    return result;
  };
};

export const getQueryParameterByName = (name) => {
  var regex, results;
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  results = regex.exec(location.search || location.href);
  if (results === null) {
    return '';
  } else {
    return decodeURIComponent(results[1].replace(/\+/g, ' '));
  }
};

export const getOrdinalCode = (grade_code) => {
  const map = {
    k: 'K',
    1: '1st',
    2: '2nd',
    3: '3rd',
    4: '4th',
    5: '5th',
    pk: 'Pre-K',
  };
  return map[grade_code];
}

export const setLandingPageUrl = () => {
  let landing_page_url_key = sessionStorage.getItem("landing_page_url");
  if (landing_page_url_key == null) {
    let landing_page_url = window.location.pathname;
    sessionStorage.setItem('landing_page_url', JSON.stringify(landing_page_url));
  }
}

export class BodyScrollLock {
  constructor() {
    this.elem = document.body;
  }
  lock(specficElem) {
    if (specficElem) this.elem = specficElem;
    this.elem.style.overflow = 'hidden';
  }
  unlock() {
    this.elem.style.overflow = '';
  }
}
// Function for finding the palyable type
export function findPlayableType(entityType) {
  if (entityType === playableTypes.gameLevelCluster || entityType === playableTypes.exploratoryGame) {
    return 'Game';
  } else if (entityType === playableTypes.worksheet) {
    return 'Worksheet';
  }
}

// Adding type of playables
export const playableTypes = {
  'gameLevelCluster': 'GameLevelCluster',
  'worksheet': 'Worksheet',
  'exploratoryGame': 'ExploratoryGame',
  'book': 'Book'
};

export const checkIfMFIsEnabledForGrade = (gradeCode, coursesArray, allGrades) => {
  //MF is not enabled for pk grade
  return gradeCode != 'pk';

  // let newMathFactEnabled = false;
  // gradeCode &&
  // coursesArray &&
  // allGrades &&
  // allGrades.get(gradeCode).courses.map((course) => coursesArray.includes(course.code) && (newMathFactEnabled = true));
  // return newMathFactEnabled;
}

const toCamelCase = (s) => {
  return s.replace(/([_][a-z])/ig, (str) => {
    return str.toUpperCase().replace('_', '');
  });
};

export const getQueryParamsObj = (paramsQueryStr, doNotConvertToCamelCase = false) => {
  paramsQueryStr = paramsQueryStr.includes('?') ? paramsQueryStr.split('?')[1] : paramsQueryStr;
  const strArr = paramsQueryStr.split('&');
  const obj = {};
  if (strArr && strArr.length) {
    strArr.forEach(el => {
      const elArr = el.split('=');
      if (doNotConvertToCamelCase) {
        obj[elArr[0]] = elArr[1];
      } else {
        obj[toCamelCase(elArr[0])] = elArr[1];
      }
    });
  }
  return { ...obj };
}

export const setCookieWithAge = (name, value, maxAge = 31536000) => {
  document.cookie = name + "=" + value + "; max-age=" + maxAge + "; path=/";
}

export const deleteCookie = (name) => {
  document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT";
}

export const getCookie = (name) => {
  let matches = document.cookie.match(new RegExp(
    "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
  ));
  return matches ? decodeURIComponent(matches[1]) : undefined;
}

export const playPauseAudio = (pause = true, pauseAnyway = false, callback = null) => {
  const blockedAudioRoutes = ['/settings', '/purchase', '/set-goal', '/student-form', '/parents', '/child-profile'];
  const route = window.location.hash;
  const isRoutePresent = () => {
    let isPresent = false;
    for (let i = 0; i < blockedAudioRoutes.length; i++) {
      if (route.includes(blockedAudioRoutes[i])) {
        isPresent = true;
        break;
      }

    }
    return isPresent;
  }
  const webAppAudio = document.getElementById('web-app-audio');
  const isPlayableLaunched = localStorage.getItem('isPlayableLaunched');
  if (webAppAudio && !isPlayableLaunched) {
    try {
      if ((pause && (isNaN(webAppAudio.duration) || webAppAudio.duration > 0) && !webAppAudio.paused) || pauseAnyway) {
        if (isIOS()) {
          webAppAudio.muted = true
        } else {
          webAppAudio.pause();
        }
      } else if (!pause && webAppAudio.paused && !isRoutePresent()) {
        webAppAudio.volume = .05;
        webAppAudio.play();
      } else if (!pause && webAppAudio.muted && !isRoutePresent()) {
        webAppAudio.muted = false;
      }
      callback && callback();
    } catch (e) {
      console.error('ERROR PAUSING/PLAYING WEB APP BACKGROUND AUDIO', e);
    }
  }
}

// to detect ipad pro10.5
export const ipadPro10_5 = () => {
  return (isIOS() &&
    (window.matchMedia("(orientation: landscape)").matches && window.innerWidth === 1112 ||
      window.matchMedia("(orientation: portrait)").matches && window.innerWidth === 1024 ||
      window.matchMedia("(orientation: portrait)").matches && window.innerWidth === 834)
  )
}

// Function for finding the next playable information acc to data passed to the function
export const findPlayableInfo = (startIndex, lastIndex, playable_items_keys, cg_playable_items, hashForCourseStatus) => {
  let nextPlayable = null;
  for (let i = startIndex; i < lastIndex; i++) {
    const lo_id = cg_playable_items.get(playable_items_keys[i]).learning_objective_id;
    const playable_id = cg_playable_items.get(playable_items_keys[i]).playable_id;

    if (!hashForCourseStatus[lo_id] || !hashForCourseStatus[lo_id][playable_id]) {
      nextPlayable = cg_playable_items.get(playable_items_keys[i]);
      break;
    }
  }
  return nextPlayable;
}

// Function for finding the next playable having less than 3 star
export const findPlayableInfoAccToStar = (playable_items_keys, cg_playable_items, hashForCourseStatus) => {
  let nextPlayable = null;
  for (let i = 0; i < playable_items_keys.length; i++) {

    const lo_id = cg_playable_items.get(playable_items_keys[i]).learning_objective_id;
    const playable_id = cg_playable_items.get(playable_items_keys[i]).playable_id;

    if (hashForCourseStatus[lo_id] && hashForCourseStatus[lo_id][playable_id] && hashForCourseStatus[lo_id][playable_id].reward_count < 3) {
      nextPlayable = cg_playable_items.get(playable_items_keys[i]);
      break;
    }
  }
  return nextPlayable;
}

export const hexToRgb = (hex, opacity) => {
  let res = hex
    .replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => '#' + r + r + g + g + b + b)
    .substring(1).match(/.{2}/g)
    .map(x => parseInt(x, 16));
  return `rgba(${res[0]},${res[1]},${res[2]}, ${opacity})`
}

// Function for converting JS date obj to Month Date, Year format like to Jan 11, 2021
export const formatDate = (date) => {
  let dateObj = new Date(date);
  let resultDate = null;
  const day = dateObj.getDate();
  const year = dateObj.getFullYear();
  const monthNo = dateObj.getMonth();
  const month = monthMapping[monthNo];

  resultDate = month + ' ' + day + ', ' + year;
  return resultDate;
};

export const monthMapping = {
  0: 'Jan',
  1: 'Feb',
  2: 'Mar',
  3: 'Apr',
  4: 'May',
  5: 'Jun',
  6: 'Jul',
  7: 'Aug',
  8: 'Sept',
  9: 'Oct',
  10: 'Nov',
  11: 'Dec'
};

/**
 *  Handling of logout for google one tap
*/
export function onSignout() {
  //disable auto-login on logout
  if (typeof google != "undefined")
    google && google.accounts && google.accounts.id && google.accounts.id.disableAutoSelect();

  // clear ptl popup cookie value on logout
  deleteCookie('hidePtlSignupPopup');
  deleteCookie("freemiumNoBlockerViaTeacherStudentCenter");
  localStorage.setItem('from_signout', 'true');
}

// @Params
//  1. key {string} -> to delete the matching property by name key
//  2. clearWhole {boolean} -> to clear whole local storage
export function clearLocalStorage(key, clearWhole) {
  if (clearWhole) localStorage.clear()
  else {
    if (localStorage.getItem(key) !== null) localStorage.removeItem(key)
  }
}

export const getDayNameFromNumber = (dayNum) => {
  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const dayName = days[dayNum];
  return dayName;
}
export const getMonthName = (dateStamp) => {
  const dateObj = new Date(dateStamp);
  const monthNo = dateObj.getMonth();
  const month = monthMapping[monthNo];
  return month;
}
export const createParamsString = (params) => {
  let url = '';
  for (const param in params) {
    if (params[param] === 0 || params[param]) {
      url += `&${param}=${params[param]}`;
    }
  }
  return '?' + url.substring(1, url.length);
}

export const getTrialEndDate = (trailDays) => {
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  let curr_date = new Date();
  let timeStampOfTrialEnd = curr_date.setDate(curr_date.getDate() + (trailDays || 7));
  let trialEndDate = new Date(timeStampOfTrialEnd);
  return `${months[trialEndDate.getMonth()]} ${trialEndDate.getDate()}, ${trialEndDate.getFullYear()}`
}

// this function will sort all null values at the end no matter the order selected
export const sortingCGAccToCreatedAt = (a, b, ascending) => {
  if (a === b)
    return 0;
  else if (a === null)
    return 1;
  else if (b === null)
    return -1;
  else if (ascending)
    return a < b ? -1 : 1;
  else
    return a < b ? 1 : -1;
}

export const durationListForSorting = ['Yearly', 'Quarterly', 'Monthly'];

// Holds the list of themes
export const themes = {
  'SplashVerse': 'splash-verse',
};

export const isSplashVerseTheme = (theme) => {
  return theme === themes['SplashVerse'];
}

export const cardType = {
  'Unlocked': 'Unlocked',
  'Locked': 'Locked',
  'Loading': 'Loading',
}

export const BadgeType = {
  'DAY': 'DAY',
  'WEEK': 'WEEK',
  'TIME': 'TIME'
}

export const ProgressState = {
  NOT_YET_STARTED: 'NOT_YET_STARTED',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  MISSED: 'MISSED',
}

export const getMathTileMapping = () => {
  const mathTiles = [
    {
      id: 1,
      code: 'ptl',
      hash: 'todo_list',
      title: 'To Do',
    },
    {
      id: 2,
      code: 'learning-path',
      hash: 'learning-path',
      title: 'Learning Path',
    },
    {
      id: 3,
      code: 'math-facts',
      hash: 'mathfacts',
      title: 'Math Facts',
    },
    {
      id: 4,
      code: 'learning-games',
      hash: 'games',
      title: 'Math Games',
    },
    {
      id: 5,
      code: 'all-topics',
      hash: 'cg-listing',
      title: 'All Topics',
    }
  ];

  return [...mathTiles];
}

export const themeState = {
  'SEEN': 'SEEN',
  'NOT_SEEN': 'NOT_SEEN'
};

export const shuffle = (array) => {
  var currentIndex = array.length, randomIndex;

  while (0 !== currentIndex) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;
    [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
  }

  return array;
}

export const getDateinYearMonthDay = (date) => { // return like this 2022-03-17
  return date.getFullYear() +
    '-' +
    (date.getMonth() + 1).toString().padStart(2, '0') +
    '-' +
    date.getDate().toString().padStart(2, '0');
}

export const getDayDateMonth = (
  dateObj
) => {
  const date = dateObj.getDate();
  const day = getDayNameFromNumber(dateObj.getDay()).slice(0, 3);
  const month = getMonthName(dateObj);
  const fullMonth = fullMonthMapping[dateObj.getMonth() + 1];
  const year = dateObj.getFullYear();
  return { day, date, month, fullMonth, year };
};

export const DATE_FORMAT_TYPES = {
  MONTH_DAY_BRACKET: "MONTH_DAY_BRACKET",
  DATE_MONTH: 'DATE_MONTH',
  DATE_FULL_MONTH_NAME: 'DATE_FULL_MONTH_NAME',
  BRACKET_DAY_MONTH_DATE: "MONTH_DAY_NO_BRACKET",
  GET_DAY: "GET_DAY",
  GET_DATE: "GET_DATE",
  DATE_FULL_MONTH_YEAR: 'DATE_FULL_MONTH_YEAR',
}

export const formattedSelectedDate = (dateObj, type = DATE_FORMAT_TYPES.MONTH_DAY_BRACKET) => {
  if (typeof dateObj == 'object') {
    const { date, day, month, fullMonth, year } = getDayDateMonth(dateObj);
    switch (type) {
      case DATE_FORMAT_TYPES.DATE_MONTH:
        return `${date}${daySuffix(date)} ${month}`;
      case DATE_FORMAT_TYPES.MONTH_DAY_BRACKET:
        return `${month} ${date} (${day})`;
      case DATE_FORMAT_TYPES.DATE_FULL_MONTH_NAME:
        return `${date}${daySuffix(date)} ${fullMonth}`;
      case DATE_FORMAT_TYPES.DATE_FULL_MONTH_YEAR:
        return `${date}${daySuffix(date)} ${fullMonth} ${year}`;
      case DATE_FORMAT_TYPES.BRACKET_DAY_MONTH_DATE:
        return `(${day}, ${month} ${date})`;
      case DATE_FORMAT_TYPES.GET_DAY:
        return `${day}`;
      case DATE_FORMAT_TYPES.GET_DATE:
        return `${date}`;
      default:
        return `(${day}, ${month} ${date})`;
    }
  }
  return '';
};

const weekDayMap = new Map([
  ['mo', 'Monday'],
  ['tu', 'Tuesday'],
  ['we', 'Wednesday'],
  ['th', 'Thursday'],
  ['fr', 'Friday'],
  ['sa', 'Saturday'],
  ['su', 'Sunday'],
]);

export const getFullNameOfWeekday = (shortSpellDay) => {
  // input -> mo
  // output -> Monday
  const day = shortSpellDay.toLowerCase();
  if (!weekDayMap.has(day)) {
    return '';
  }
  return weekDayMap.get(day);
};

export const getShortNameOfWeekday = (day) => {
  // input -> mo
  // output -> Mon
  const fullSpellingDay = getFullNameOfWeekday(day);
  if (fullSpellingDay === '') {
    return '';
  }
  return fullSpellingDay.slice(0, 3);
};
export const GamificationMapper = ({ grade }) =>
({
  text: {
    "math-facts": ["pk", "k"].includes(grade) ? "Launch a custom math facts quiz" : "Practice your Math Facts with a magical twist",
    "learning-games": "Up for fun? Learn while you play",
    "all-topics": "Look for any specific <grade> skill here",
    "bs": "Drift off to dreamland",
    "lr1": "Look for any specific <grade> skill here",
    "rw": "Blend sounds and begin reading words",
    "az": "Explore letter names and sounds",
    "sw": "Learn common words and read faster",
    "db": "The magic of independent reading",
    "se": "A, B, C, D. Won’t you sing with me?",
    "tr": "Follow the dots and trace the alphabet!",
    "ls": "Learn letter names and sounds",
    "lr": "Fun stories mapped to your reading level",
    "sp": "Cast spells to be a Spelling Champion!",
    "rc": "Unlock the joy of reading while playing",
    "ob": "Read about adventures of Oddbods",
    "pz": "Ready for a multiplayer battle?",
  },
  color: {
    "math-facts": "#A5F9E8",
    "learning-games": "#F1DAFA",
    "all-topics": "#7678DF",
    "bs": "#4E9DE8",
    "lr1": "#F1DAFA",
    "rw": "#F1DAFA",
    "az": "#FFE6DF",
    "sw": "#FFE6DF",
    "db": "#FFE6DF",
    "se": "#F1DAFA",
    "tr": "#FFE6DF",
    "ls": "#D3E6F9",
    "lr": "#E2B5F5",
    "sp": "#DBFDF6",
    "rc": "#FFE6DF",
    "ob": "#51C5FF",
    "pz": "#DBFDF6",
  },

  width: {
    "66%": "two-third",
    "50%": "one-two",
    "33%": "one-third"
  }
})
export const convertToUUIDFormat = (id) => {
  let result = '';
  if (id) {
    result +=
      id.substr(0, 8) +
      '-' +
      id.substr(8, 4) +
      '-' +
      id.substr(12, 4) +
      '-' +
      id.substr(16, 4) +
      '-' +
      id.substr(20, 12);
  }
  return result.toLowerCase();
};

export const revertUUIDFormat = (uuid) => {
  return uuid.split('-').join('').toUpperCase();
}

// utility function which converts time 18:00:00 to 6:00PM
export function tConvert(time, returnInSmallCase) {
  let beforeNoon = returnInSmallCase ? ' am' : ' AM';
  let afterNoon = returnInSmallCase ? ' pm' : ' PM';
  let timeSliced = time.slice(0, -3);
  // Check correct time format and split into components
  let timeArr = timeSliced.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [timeSliced];

  if (timeArr.length > 1) { // If time format correct
    timeArr = timeArr.slice(1);  // Remove full string match value
    timeArr[5] = +timeArr[0] < 12 ? beforeNoon : afterNoon; // Set AM/PM
    timeArr[0] = String(+timeArr[0] % 12 || 12); // Adjust hours
  }
  return timeArr.join(''); // return adjusted time or original string
}

const fullMonthMapping = {
  1: 'January',
  2: 'February',
  3: 'March',
  4: 'April',
  5: 'May',
  6: 'June',
  7: 'July',
  8: 'August',
  9: 'September',
  10: 'October',
  11: 'November',
  12: 'December'
};

// returns st, nd, rd, th based on day input
export const daySuffix = (day) => {
  day = Number(day);
  if (day > 3 && day < 21) return 'th';
  switch (day % 10) {
    case 1: return 'st';
    case 2: return 'nd';
    case 3: return 'rd';
    default: return 'th';
  }
}

// input date format -> YYYY-MM-DD
// output -> Date Month
// eg: 2021-07-01 -> 1st July
export function convertDate(date) {
  if (!date) return '';
  const [year, month, day] = date.trim().split('-');
  return (Number(day)).toString() + daySuffix(day) + ' ' + fullMonthMapping[Number(month)];
}

export const DATE_STRING_FORMAT_TYPES = {
  DATE_FULL_MONTH: "DATE_FULL_MONTH",
  DATE_FULL_MONTH_YEAR: 'DATE_FULL_MONTH_YEAR',
}
// date should be input in this format -> YYYY-MM-DD
export function formatDateString(date, formatType = '') {
  if (!date) return '';
  const [year, month, day] = date.trim().split('-');
  switch (formatType) {
    case DATE_STRING_FORMAT_TYPES.DATE_FULL_MONTH: {
      return (Number(day)).toString() + daySuffix(day) + ' ' + fullMonthMapping[Number(month)];
    }
    case DATE_STRING_FORMAT_TYPES.DATE_FULL_MONTH_YEAR: {
      return (Number(day)).toString() + daySuffix(day) + ' ' + fullMonthMapping[Number(month)] + ' ' + year;
    }
    default: {
      return (Number(day)).toString() + daySuffix(day) + ' ' + fullMonthMapping[Number(month)];
    }
  }
}

export const dateDiffInSeconds = (dateString) => {
  const dt = new Date(dateString)
  return Math.ceil((dt - Date.now()) / 1000);
}

export const shouldShowFMTPendingModal = ({ currentSubjectCode, assignmentMandatory, learningPlanMandatory, assignmentList, assessmentList, learningPlanList }) => {
  //If pending activities from teacher show PendingActivityFMTModal (only for B2B math dashboard)

  const store = Store.getState();
  let isClassroomStudent = store.settings.is_classroom_student;
  let isHomeMode = store.settings.restriction_info?.selected_mode === 'home';
  let viaTeacherStudentCenter = store.settings.via_teacher_student_center;
  if(isClassroomStudent && isHomeMode && !viaTeacherStudentCenter) {
    return false;
  }
  let isAssignmentMandatoryAndPending = assignmentMandatory &&
    (
      assignmentList.filter(
        (as) => as.course_code.includes(currentSubjectCode)
      ).length > 0
    );
  if (isAssignmentMandatoryAndPending) return true;

  if (currentSubjectCode == 'math') {
    let isAssessmentPending = assessmentList.length > 0;
    if (assignmentMandatory && isAssessmentPending) return true;

    // if (assignmentMandatory && (store?.fact_fluencies?.length > 0)) return true;

    if (learningPlanMandatory) {
      let learningPlanCount = 0;
      learningPlanList.map((item) => {
        learningPlanCount += item.learning_objectives.length;
      });
      return (learningPlanCount > 0);
    }
  }

  return false;
}

export const canPlayHelper = async (params, playableData = {}) => {
  return canPlayHelperUtility(params, playableData);
}

export const validateEmail = (email) => {
  let err = '';

  if (!email || email.trim().length == 0)
    err = "Email can't be blank";

  else if (email) {
    if (!REGEX_COLLECTION.EMAIL_REGEX.test(email)) {
      err = "Email is invalid"
    }
  }

  return {
    validated: err ? false : true,
    error: err
  }
}

export const validatePassword = (password) => {
  let err = ""
  if (!password) {
    err = 'Password is required';
  }
  else if (password.length < 6) {
    err = 'Too short, password must be at least 6 characters';
  }

  return {
    validated: err ? false : true,
    error: err
  }
}

export const saveHeaderVariationInStorage = (value) => {
  sessionStorage.setItem('selectedHeaderVariation', value);
}

export const getHeaderVariationInStorage = () => {
  return sessionStorage.getItem('selectedHeaderVariation');
}

export const attachHandlerForAppConfig = () => {
  // attaching a handler in window object to set the device config from app side
  window.setAppDeviceConfig = (config) => {
    if (config) {
      localStorage.setItem('appDeviceConfig', JSON.stringify(config));
    }
  }
}

export const showParentTeacherBtnInIOS = () => {
  try {
    const appConfig = JSON.parse(localStorage.getItem('appDeviceConfig'));
    const LoginType = appConfig && appConfig['Login Type'];
    if (['Parent', 'Teacher', 'Guest'].includes(LoginType)) {
      if (LoginType == 'Teacher') return [true, 'Teacher'];
      else return [true, 'Parents'];
    }
    return [false, 'Parents'];
  } catch (e) {
    console.log(e);
    return [false, 'Parents'];
  }
};

// function for emitting callbacks to web view
export const emitMessageToWebView = (message) => {
  if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.webViewMessageEmitter) {
    window.webkit.messageHandlers.webViewMessageEmitter.postMessage({
      "message": message
    });
  }
}

// function for sending callback for popup shown to webview
export const emitPopupShown = () => {
  emitMessageToWebView('POPUP_SHOWN');
}

// function for sending callback for popup dismissed to webview
export const emitPopupDismissed = () => {
  emitMessageToWebView('POPUP_DISMISSED');
}

// Set cookies for onboarding coachmark flow
export const setCoachmarkFlag = () => {
  sessionStorage.setItem('showOnboardingCoachmark', true);
}

// Get cookies for onboarding coachmark flow
export const getCoachmarkFlag = () => {
  return Boolean(sessionStorage.getItem('showOnboardingCoachmark'));
}

// delete cookies for onboarding coachmark flow
export const removeCoachmarkFlag = () => {
  sessionStorage.removeItem('showOnboardingCoachmark');
}

//Function to set local storage item to hide parent dashboard tour
export const hideParentDashboardTour = () => {
  sessionStorage.setItem('hideParentDashboardTour', 'true');
}

//Function to check whether to show Parent Dashboard Tour or not
export const canShowParentDashboardTour = () => {
  if (sessionStorage.getItem('hideParentDashboardTour') === 'true')
    return false;
  return true;
}
//Show Oddbods books tile
export const showOddbodsBooks = ({ gradeCode, subjectCode, isClassroomStudent }) => {
  const validGradesForOddbods = ['k', '1', '2'];

  if (validGradesForOddbods.indexOf(gradeCode) != -1 && subjectCode === 'ela' && !isClassroomStudent)
    return true;

  return false;
}
// condition to show PTLSignup component
export const showPTLSignup = ({ restrictionInfo, show3pmPopup, viaTeacherStudentCenter }) => {
  return restrictionInfo && show3pmPopup && !viaTeacherStudentCenter
}

export const convertToMins = (seconds) => {
  return seconds ? Math.floor(seconds / 60) : 0;
}

export const convertToSeconds = (mins) => {
  return mins ? Math.floor(mins * 60) : 0;
}

// Method to generate the list of dates for the current week starting from monday in YYYY-MM-DD format
export const getCurrentWeekDates = () => {
  const curr = new Date();
  let weeks = [], first = null, day = null;

  for (let i = 1; i <= 7; i++) {
    first = curr.getDate() - curr.getDay() + i
    day = new Date(curr.setDate(first)).toISOString().slice(0, 10)
    weeks.push(day);
  }

  return weeks;
}

export const WeeklyGoalDayMap = {
  'Monday': 1,
  'Tuesday': 2,
  'Wednesday': 3,
  'Thursday': 4,
  'Friday': 5,
  'Saturday': 6,
  'Sunday': 7
}


//Function to send error to sentry
export const sendErrorToSentry = (err, errorInfo) => {
  if (err) {
    Sentry.withScope((scope) => {
      errorInfo && Object.keys(errorInfo).length && scope.setExtras(errorInfo);
      const eventId = Sentry.captureException(err);
      return eventId;
    });
  }
  else
    return null;
}
export const sendMessageToSentry = (message, extraInfo, tag) => {
  if (message) {
    Sentry.withScope((scope) => {
      tag && scope.setTag(tag);
      extraInfo && Object.keys(extraInfo).length && scope.setExtras(extraInfo);
      const eventId = Sentry.captureMessage(message, Sentry.Severity.Debug);
      return eventId;
    });
  }
  else
    return null;
}

export const sendEventUsingAvo = ({ methodName, params }, appendBaseParams= false) => {
  const environment = getHostName() == 'production' ? 'prod' : 'staging';
  
  if (appendBaseParams) {
    const queryParams = getQueryParamsObj(window.location.hash);
    const childGrade = queryParams.addChild ? queryParams.grade.toString() : '';
    const Store = require('../stores/student-dashboard').Store;
    let settings = JSON.parse(localStorage.getItem('user_settings')) || {};
    let student = JSON.parse(localStorage.getItem('user_student')) || {};
    let courses = JSON.parse(localStorage.getItem('user_course')) || [];
    let mathGrade = '';
    let elaGrade ='';
    let grade = '';
    
    if(Object.keys(student).length){
      mathGrade = student.subject_wise_grade['Math Grade'];
      elaGrade = student.subject_wise_grade['Ela Grade'];
    }
    /// To handle grade in add child case
    if(Object.keys(student).length ==0 && courses.length == 0 && childGrade){
      grade = childGrade;
      mathGrade = childGrade;
      elaGrade = childGrade;
    }
   
    let baseParams = getBaseParams({
      settings: settings,
      courses: courses,
      mathGrade: mathGrade,
      elaGrade: elaGrade,
    });
    params = { ...params, ...baseParams };
  }
  if (methodName) {
    try {
      Avo.initAvo({ env: environment }, {}, {}, AvoDestination);
      Avo.setSystemProperties({ screenHeight: window.innerHeight });
      Avo[methodName](params);
    }
    catch (error) {
      console.error(error);
    }
  }
}

export const getTimeZoneAbbrevation = () => {
  var fullTz = new Date().toString().match(/\(([A-Za-z\s].*)\)/)[1];
  var parts = fullTz.split(' ');
  var tz = '';
  parts.forEach(function (element) {
    tz += element.substring(0, 1);
  });
  return tz;
}

export const createWrapper = (initialState, rootReducer) => {
  const store = createStore(rootReducer, initialState);

  const Wrapper = ({ children }) => (
    <Provider store={store}>{children}</Provider>
  );

  return Wrapper;
}

export const connectWithStoreWrapper = (
  mapStateToProps,
  dispatchStateToProps,
  component
) => {
  const connect = require('react-redux').connect;

  var ConnectedComponent = connect(
    mapStateToProps,
    dispatchStateToProps
  )(component);
  return function (props) {
    return <ConnectedComponent {...props} />;
  };
}


export const getCDNAssetURL = () => {
  const secrets = require('../../../public_keys.json')
  return secrets.cdn_asset_url;
}

// get user country code
export const getUserCountryCode = () => {
  let countryCodeFromServer;
  const Store = require('../stores/student-dashboard').Store;
  const { country_code } = Store.getState().settings;
  if (country_code) {
    countryCodeFromServer = country_code;
  }
  else {
    const Store = require('../stores/parent-dashboard').Store;
    const { country_code } = Store.getState().settings;
    countryCodeFromServer = country_code;
  }
  // const countryCode =  (getUserCountryCode() || country_code);

  var userCity;
  var userCountryCode;
  var userTimeZone;

  if (Intl) {
    userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    var tzArr = userTimeZone.split("/");
    userCity = tzArr[tzArr.length - 1];
    userCountryCode = cityCountryCodeMapping[userCity];
  }
  if (['US', 'CA'].includes(userCountryCode)) {
    return userCountryCode;
  } else if (['US', 'CA'].includes(countryCodeFromServer)) {
    return countryCodeFromServer;
  }
  else {
    return userCountryCode || countryCodeFromServer;
  }
}

// function for awating
const timeout = (ms) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

//Assigns abtests to user using abtest service
export const assignAbTestsToUser = async (userId, gradeCode) => {
  const supportedABTestList = ["Parent::Premium_live_plan", "Parent::DynamicPositioning", "Parent::Companion", "Parent::NewCOQs", "Parent::FlutterOnboarding",
     "Parent::New_Learning_Path_Free_LP", "Parent::New_Learning_Path", "Parent::PLPlanSingleCTA", 
     "Parent::PlayableImprovementV1", "Parent::GameHeaderV1", "Parent::Onboarding_Daily_Bundle",
    "Parent::Dashboard_Adaptive_Algo_V1", "AB_PA:B2CP:NU:OB:AL:CrossPlatformAppDownload", "Parent::OB_BookMonetisation"];
  const countryCode = getUserCountryCode();
  try {
    let listOfABTest = getAbTestsFromURL();
    let userSignupFlow = getUserSignupFlow()
    if (userId) {
      let response = await AssignAbTests(convertToUUIDFormat(userId), {
        user_parameters: {
          user_type: 'parent',
          source: 'web',
          grade: gradeCode,
          user_signup_flow: userSignupFlow,
          user_preferred_language: getUserPreferredLanguage(),
          user_country_code: countryCode,
          device_type: getDeviceType(),
        },
        force_assign_ab_test_segments: listOfABTest,
        supported_ab_test_features: supportedABTestList  //@todo Mohit  // this param force assign Abtests to users
      });
      if (response && response.hasOwnProperty('newly_assigned_ab_tests') && Object.keys(response.newly_assigned_ab_tests).length > 0) {
        try {
          await timeout(1000);
          $.get('/custom_tracking_methods').then(function (data) {
            return $('body').append(data);
          });
        } catch (e) {
          console.error(e);
        }
      }
      return response
    }
  } catch (err) {
    console.error(err);
    let errorInfo = {
      extraMsg: 'AssignAbTestsApi failed',
    };
    sendErrorToSentry(err, errorInfo);
  }
}
//  @Params
//  1. resp {key,value} -> assigned abtest api response
//  2. abTestNameAndSegmentMapArr [{key,value}] -> key is abtestname and value is segment name to check against
function isSegmentEqualToAssignedSegment(resp, abTestNameAndSegmentMapArr) {
  const namesegmentmap = new Map()
  for (let key of abTestNameAndSegmentMapArr) {
    const [[abTestName, segment]] = Object.entries(key)
    namesegmentmap.set(abTestName, resp[abTestName] == segment)
  }
  return namesegmentmap
}

//Get Abtests from the query params of the url saved in the cookie
//http://localhost:3000/parents/register?ab_test[Parent::Playzone]=Playzone_On_New (Example URL)
export const getAbTestsFromURL = () => {
  let url = getCookie('url');
  let listOfABTest = (url?.slice(url.indexOf('?') + 1))?.split('&');
  let obj = {}
  if (listOfABTest) {
    for (let abTest of listOfABTest) {
      let start = abTest.indexOf('[');
      let end = abTest.indexOf(']');
      let key = abTest.slice(start + 1, end)
      let value = abTest.slice(abTest.indexOf('=') + 1)
      obj[key] = value
    }
  }
  return obj
}

//handle flags to show nudge on Playzone tab & tile
export const setFingerNudgeFlagForPzTab = (flag) => {
  sessionStorage.setItem('canShowFingerOnPlayzoneTab', flag);
}

// Set flags for 1st time PZ finger Nudge flow
export const setFingerNudgeFlagForPzTile = (flag) => {
  localStorage.setItem('canShowFingerOnPlayzoneTile', flag);
}

// Set functions for first login (works for B2B,B2C & PTL users)
export const setFirstTimeLogin = () => {
  setCookieWithAge('firstTimeLoginDone', true, '86400'); //hasOneDayPassedAfterSignIn tells if this is the first day, he cookie helps in maintaining if it's the first login
  setFingerNudgeFlagForPzTile(true);
}

// Return true if first session of user on it's first day (only called on the 1st day of user)
export const isFirstTimeLogin = () => {
  return getCookie('firstTimeLoginDone') !== "true";
}

// Return true if user has math subscription or accessing during school hours (B2C and PTL users)
export const hasMathFactsAccess = ({
  hasMathAccess,
  canPlayFreeCardsFromAnywhere,
  selectedMode
}) => {
  let hasAccess = hasMathAccess || (canPlayFreeCardsFromAnywhere && selectedMode === "school");
  if (hasAccess) {
    return true
  } else {
    return false;
  }
}


export const calculateDaysBetweenTwoDates = (date1, date2) => {
  const diff = Math.abs(date1.getTime() - date2.getTime());
  return Math.ceil(diff / (1000 * 3600 * 24));
}

export const getDeviceType = () => {
  if (isMobileDevice())
    return 'mweb';
  else if (isTabletDevice())
    return 'tweb';
  else
    return 'desktop'
}

export const padTo2Digits = (num) => {
  return num.toString().padStart(2, '0');
}

function hmsToSeconds(s) {
  let toSeconds = s.split(':');
  return toSeconds[0] * 3600 + toSeconds[1] * 60 + (+toSeconds[2] || 0);
}

export const getTimeDifference = (popupTime = '15:00:00') => {
  const date = new Date();

  const localTime = [
    padTo2Digits(date.getHours()),
    padTo2Digits(date.getMinutes()),
    padTo2Digits(date.getSeconds()),
  ].join(':')

  const diff = hmsToSeconds(popupTime) - hmsToSeconds(localTime)
  return (diff * 1000);
}

// return Stripe Promise
export const getStripePromise = (stripeKey) => {
  if (stripeKey) {
    return loadStripe(stripeKey);
  } else {
    return null;
  }
};
export const setUserSignupFlow = (value) => {
  sessionStorage.setItem("user_signup_flow", value);
}

export const getUserSignupFlow = () => {
  return sessionStorage.getItem("user_signup_flow") || "";
}

export const showMBG = () => {
  let newMBG = getABTestValue('Parent', 'NewMBG')
  if (newMBG === "MBG")
    return true
  return false
}

export const highestGradeCode = (courses) => {
  if (!courses || courses.length == 0) {
    const parentStore = require('../stores/parent-dashboard').Store;
    const { student } = parentStore.getState();
    const studentStore = require('../stores/student-dashboard').Store;
    const { student: studentFromStudentStore } = studentStore.getState();
    return fetchHighestUserGrade(student?.id || studentFromStudentStore?.id);
  }
  let courseObj = [], maxGrade = -1;
  for (const item of courses) {
    if (gradeMappingForCompare[item.grade_code] > maxGrade) {
      maxGrade = gradeMappingForCompare[item.grade_code];
      courseObj = item;
    }
  }
  return courseObj?.grade_code;
}


export const highestGradeCodeForUpcomingLiveClass = (student, courses) => {
  let courseObj = [], maxGrade = -1;
  if (student.is_classroom_linked) {
    return student.classroom_grade;
  }
  else {
    for (const item of courses) {
      if (gradeMappingForCompare[item.grade_code] > maxGrade) {
        maxGrade = gradeMappingForCompare[item.grade_code];
        courseObj = item;
      }
    }
    return courseObj?.grade_code;
  }
}

export const canMakePaymentStripeApiResponse = async (stripeKey) => {
  let canMakePaymentResult = null;
  if (stripeKey) {
    const stripe = await loadStripe(stripeKey);
    if (stripe) {
      const paymentRequest = stripe.paymentRequest({
        country: 'US',
        currency: 'usd',
        total: {
          label: 'Test Product',
          amount: 0,
        },
      });
      if (paymentRequest) {
        canMakePaymentResult = await paymentRequest.canMakePayment()
      }
    }
  }
  localStorage.setItem('canMakePaymentStripeApiResponse', JSON.stringify(canMakePaymentResult));
};

export const canByPassAgeGate = () => {
  const result = JSON.parse(localStorage.getItem('canMakePaymentStripeApiResponse'));
  const payment_request_button_enabled = getABTestValue("Parent", "PaymentRequestButtonWithAgeGate") === "prb_on" ? true : false

  return !(result && result.hasOwnProperty('googlePay') && result.googlePay && payment_request_button_enabled)
}

export const canUserPlayPlayzoneGame = async (userDetails, settings) => {
  let userCanPlay = true;
  if (!(settings.has_ela_access || settings.has_math_access) && !(settings.is_classroom_student && settings?.restriction_info?.selected_mode === 'school')) {
    await CheckUserCanPlayPlayzoneGame(userDetails).then((data) => {
      userCanPlay = data.can_play;
    });
  }
  return userCanPlay;
}

export const dateBetweenTwoDates = (startDate, endDate) => {
  const currentDate = new Date().toJSON().slice(0, 10);
  const check = new Date(currentDate);
  return (startDate <= check && check <= endDate);
}

export const halloweenStartDate = new Date('2022/10/20');
export const halloweenEndDate = new Date('2022/11/10');

const returnDashboardCodeBasedOnDRSLiveClassesTrial = (segmentName) => {
  if (segmentName === 'DRSWithoutTrial' || segmentName === 'DRSWithTrial') {
    return segmentName = 'Topics_Out_On_DRS'
  }
  if (segmentName === 'DRSWithLiveClasses') {
    return segmentName;
  }
}

export const getFreemiumAbTestAssignedSegment = () => {
  const Store = require('../stores/student-dashboard').Store;
  const { abTests } = Store.getState();

  // checking for DRSLiveClassesTrial segment on Parent
  let parentFreemiumAbTestAssignedSegment = getABTestValue('Parent', 'DRSLiveClassesTrial');

  if (parentFreemiumAbTestAssignedSegment && parentFreemiumAbTestAssignedSegment != 'Control') {
    parentFreemiumAbTestAssignedSegment = returnDashboardCodeBasedOnDRSLiveClassesTrial(parentFreemiumAbTestAssignedSegment);
  }
  else {
    // checking for Freemium_Topics_Out segment on Parent
    parentFreemiumAbTestAssignedSegment = getABTestValue('Parent', 'Freemium_Topics_Out') || "";
  }

  // checking for DRSLiveClassesTrial segment on Teacher
  let teacherFreemiumAbTestAssignedSegment = abTests && abTests?.teacher && abTests.teacher['Teacher::DRSLiveClassesTrial'] || "";
  if (teacherFreemiumAbTestAssignedSegment && teacherFreemiumAbTestAssignedSegment != 'Control') {
    teacherFreemiumAbTestAssignedSegment = returnDashboardCodeBasedOnDRSLiveClassesTrial(teacherFreemiumAbTestAssignedSegment);
  }
  else {
    // checking for Freemium_Topics_Out segment on Teacher
    teacherFreemiumAbTestAssignedSegment = abTests && abTests?.teacher && abTests.teacher['Teacher::Freemium_Topics_Out'] || ""
  }

  return {
    parentFreemiumAbTestAssignedSegment,
    teacherFreemiumAbTestAssignedSegment
  }
}

export const getDRSLiveClassesTrialAbTestAssignedSegment = () => {
  const Store = require('../stores/student-dashboard').Store;
  const { abTests } = Store.getState();
  const parentDRSLiveClassesTrialAbTestAssignedSegment = getABTestValue('Parent', 'DRSLiveClassesTrial') || "";
  const teacherDRSLiveClassesTrialAbTestAssignedSegment = abTests && abTests?.teacher && abTests.teacher['Teacher::DRSLiveClassesTrial'] || "";

  return {
    parentDRSLiveClassesTrialAbTestAssignedSegment,
    teacherDRSLiveClassesTrialAbTestAssignedSegment
  }
}

export const isMultiplayerGamesLockedAbTestAssignedToTeacher = () => {
  const Store = require('../stores/student-dashboard').Store;
  const { abTests } = Store.getState();
  const teacherMultiplayerGamesLockedAbTestAssignedSegment = abTests && abTests?.teacher && abTests.teacher['Teacher::MultiplayerGamesLocked'] === "LockedSegment";

  return {
    teacherMultiplayerGamesLockedAbTestAssignedSegment
  }
}

const Helper = {
  assetPath: assetPath,
  avatarUrl: avatarUrl,
  playableImage: playableImage,
  gameImage: gameImage,
  isIOS: isIOS
};

export default Helper;


export function getSubjectGradeAndText(subject_wise_grade) {
  const ELAGrade = subject_wise_grade["Ela Grade"];
  const MathGrade = subject_wise_grade["Math Grade"];
  const MathGradeOrdinalCode = getOrdinalCode(MathGrade) || "Pre-K";
  const ELAGradeOrdinalCode = getOrdinalCode(ELAGrade) || "Pre-K";
  const MathGradeText = `${i18n.t('Math')}: ${i18n.t('settings.grade.' + MathGradeOrdinalCode)}`
  const ELAGradeText = `Reading: ${i18n.t('settings.grade.' + ELAGradeOrdinalCode)}`
  return { MathGrade, MathGradeText, ELAGrade, ELAGradeText }
}

export const getActiveTabCode = () => {
  return sessionStorage.getItem(ACTIVE_TAB_CODE_KEY) || '';
}

export const setActiveTabCode = (code) => {
  return sessionStorage.setItem(ACTIVE_TAB_CODE_KEY, code);
}

// To set item in localstorage
export const setItemInLocalStorage = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
}

// To get item from localstorage
export const getItemFromLocalStorage = (key) => {
  const value = localStorage.getItem(key);
  try{
    return JSON.parse(value);
  }
  catch(err){
    return value;
  }
 
}

// To remove item from local storage
export const deleteItemFromLocalStorage = (key) => {
  return localStorage.removeItem(key);
}

// Time localisation for t2 classes
export const getLiveClassTimeInUserTimeZone = () => {
  const Store = require('../stores/student-dashboard').Store;
  const { student, ptlParent } = Store.getState();
  const timeZone = ptlParent ? ptlParent.time_zone : student.time_zone;
  switch (timeZone) {
    case 'Hawaii': {
      return '2:30';
    }
    case 'Alaska': {
      return '3:30';
    }
    case 'Pacific Time (US & Canada)': {
      return '4:30';
    }
    case 'Arizona': {
      return '5:30';
    }
    case 'Mountain Time (US & Canada)': {
      return '5:30';
    }
    case 'Central Time (US & Canada)': {
      return '6:30';
    }
    case 'Eastern Time (US & Canada)': {
      return '4:30';
    }
    default: {
      return '4:30';
    }
  }
}

// To calculate time difference in minutes between 2 timestamps in milliseconds
export const fetchDiffInMinsBetweenTimestamps = (time1, time2) => {
  return (time2 - time1) / (60 * 1000);
}

export const fetchTabNameForGamification = () => {
  const headerName = sessionStorage.getItem('selectedHeaderVariation')
  if (headerName == TypesOfModes['Math']) {
    return "curriculum";
  }
  else if (headerName == TypesOfModes['MultiPlayer']) {
    return "game_zone";
  }
  else if (headerName == TypesOfModes['LiveClass']) {
    return "live_class";
  }
  return;
}

// if the user onboards via 3PM popup directly & not logged in via student experience flow
// these values are set in cookies only when FreemiumNoBlocker ABTest is assigned
export const onboardVia3PmPopupOrStudentExp = () => {
  if (getCookie("hidePtlSignupPopup") != "true" && getCookie("freemiumNoBlockerViaTeacherStudentCenter") != "true") {
    return true;
  }
  return false;
}

export const isImageCodeOrUrl = (imageData) => {
  if (imageData && imageData.includes('http')) {
    return "imageUrl";
  }
  else {
    return "imageCode";
  }
}

export const fetchAgeNumberFromAgeAndGrade = (grade, index) => {
  // index is referred of array ageNumber = ['Less than 3 years old', '3 years old', '4 years old', '5 years old', 'More than 5 years old'];
  switch (grade) {
    case 'pk':
      return index == 0 ? 2 : (index == 1 ? 3 : 4);
    case 'k':
      return 5;
    default:
      return null; //To handle invalid grade
  }
}

export const t2EligibleUserOnTheBasisOfCountryCode = () => {
  const Store = require('../stores/student-dashboard').Store;
  const country_code = getUserCountryCode();
  const { courses } = Store.getState();
  let highestGrade = highestGradeCode(courses);

  let userCountry = (country_code) || "IN";
  if (userCountry === 'US' || userCountry === 'CA') {
    if (highestGrade === 'pk') {
      return false;
    }
    return true;
  }
}

export const fetchImageUrlForNewOnboarding = (path, image) => {
  // Replacing '&' in image with '_'
  image = image.replace(/&/g, "_");
  const cdnAssetUrl = getCDNAssetURL();
  return `${cdnAssetUrl}${path}${image}.svg`;
}

export const getItemFromSessionStorage = (key) => {
  const item = sessionStorage.getItem(key)
  try {
    return JSON.parse(item);
  } catch (e) {
    return item;
  }
}
// this function returns true for higher grades which are not supported for Reading
export const skipGradesForSubjectSelection = () => {
  const language = i18n.language;
  const { selectedGrade } = getItemFromLocalStorage('splashverse-onboarding');
  switch (language) {
    case 'en-GB':
      return [SECOND_GRADE, THIRD_GRADE, FOURTH_GRADE, FIVE_GRADE].includes(selectedGrade);
    case 'en-AU':
      return [THIRD_GRADE, FOURTH_GRADE, FIVE_GRADE].includes(selectedGrade);
    default:
      return false;
  }
}

// this function returns true for UK country
export const isUKCountry = () => {
  return ['en-GB'].includes(i18n.language);
}

// this function returns true for Australia country
export const isAUCountry = () => {
  return ['en-AU'].includes(i18n.language);
}

export const capitalizeFirstLetter = (name) => {
  return name[0].toUpperCase() + name.slice(1)
}

export const fetchStudentIdFromStore = () => {
  const Store = require('../stores/student-dashboard').Store;
  const parentStore = require('../stores/parent-dashboard').Store;
  const { student } = Store.getState();
  const { student: studentFromParent } = parentStore.getState();
  const studentId = student && student.id || (studentFromParent && studentFromParent.id);

  return studentId;
}

// This function returns true if scroll tracking event has to fired in a day for a rail
export const shouldFireEventForRail = (railCode) => {
  const currentDate = new Date().toLocaleDateString();
  const scrollTrackingData = getCookie(`Scroll_Tracking_Of_${railCode}_For_${fetchStudentIdFromStore()}`);
  const scrollTrackingDataObj = scrollTrackingData && JSON.parse(scrollTrackingData);

  if (scrollTrackingDataObj && scrollTrackingDataObj.eventSent == true && scrollTrackingDataObj.currentDate == currentDate) { // if event has been fired in a day
    return false;
  }
  else if (fireEventForRailOnceInADay(railCode)) { // if event is not fired in a day for a rail
    return true;
  }

  return false;
}

// mark event sent as true with current date for a single rail
export const markRailEventAsSent = (railCode) => {
  setCookieWithAge(`Scroll_Tracking_Of_${railCode}_For_${fetchStudentIdFromStore()}`, `{"eventSent": "true", "currentDate": "${new Date().toLocaleDateString().toString()}"}`)
}

// This function returns true when event for a rail has not been fired in a day and if day changes then currentDate is updated
export const fireEventForRailOnceInADay = (railCode) => {
  const currentDate = new Date().toLocaleDateString();
  const scrollTrackingData = getCookie(`Scroll_Tracking_Of_${railCode}_For_${fetchStudentIdFromStore()}`);
  const scrollTrackingDataObj = scrollTrackingData && JSON.parse(scrollTrackingData);
  if (scrollTrackingDataObj && scrollTrackingDataObj.currentDate == currentDate) {
    return false;
  }
  else {
    setCookieWithAge(`Scroll_Tracking_Of_${railCode}_For_${fetchStudentIdFromStore()}`, `{"eventSent": "false", "currentDate": "${currentDate.toString()}"}`);
    return true;
  }
}

// Get class when Flutter Dashboard is assigned
export const getFlutterDashboardClass = () => 'flutter-dashboard';

export const getTimein12FormatNew = (hours) => {
  let suffix = (hours >= 12) ? 'PM' : 'AM';
  let time = ((hours + 11) % 12 + 1);
  return `${time}${suffix}`;
}

export const scrollTrackOnLiveClassPurchase = (element, pageName) => {
  if (element.offsetHeight + element.scrollTop >= element.scrollHeight - 1 && fireCompleteScrollOnLCPurchase(pageName)) {
    sendEventUsingAvo({ methodName: 'completedPageScroll', params: { 'pageName': pageName } });
    markCompleteScrollOnLCPurchase(pageName);
  }
}

// This function returns true when event for live class plan page/summary page has not been fired in a day and if day changes then currentDate is updated
export const fireCompleteScrollOnLCPurchaseOnceInADay = (railCode) => {
  const currentDate = new Date().toLocaleDateString();
  const scrollTrackingData = getCookie(`Scroll_Tracking_Of_${railCode}_For_${fetchStudentIdFromStore()}`);
  const scrollTrackingDataObj = scrollTrackingData && JSON.parse(scrollTrackingData);
  if (scrollTrackingDataObj && scrollTrackingDataObj.currentDate == currentDate) {
    return false;
  }
  else {
    setCookieWithAge(`Scroll_Tracking_Of_${railCode}_For_${fetchStudentIdFromStore()}`, `{"eventSent": "false", "currentDate": "${currentDate.toString()}"}`);
    return true;
  }
}

// This function returns true if scroll tracking event has to be fired in a day for live class plan page/summary page
export const fireCompleteScrollOnLCPurchase = (pageName) => {
  const currentDate = new Date().toLocaleDateString();
  const scrollTrackingData = getCookie(`Scroll_Tracking_Of_${pageName}_For_${fetchStudentIdFromStore()}`);
  const scrollTrackingDataObj = scrollTrackingData && JSON.parse(scrollTrackingData);

  if (scrollTrackingDataObj && scrollTrackingDataObj.eventSent == true && scrollTrackingDataObj.currentDate == currentDate) { // if event has been fired in a day
    return false;
  }
  else if (fireCompleteScrollOnLCPurchaseOnceInADay(pageName)) { // if event is not fired in a day for live class plan page/summary page
    return true;
  }

  return false;
}

// mark event sent as true with current date for live class plan page/summary page
export const markCompleteScrollOnLCPurchase = (pageName) => {
  setCookieWithAge(`Scroll_Tracking_Of_${pageName}_For_${fetchStudentIdFromStore()}`, `{"eventSent": "true", "currentDate": "${new Date().toLocaleDateString().toString()}"}`)
}
// Convert UTC time to Local Time
export const getLocalTime = (utcTime) => {
  if (!utcTime)
    return "";
  let date = new Date().toJSON().slice(0, 10).replace(/-/g, '-');
  var createdDateTime = new Date(`${date}T${utcTime}Z`);
  let localTime = createdDateTime.toLocaleTimeString([], { hour12: true, hour: "2-digit", minute: "2-digit" });

  let arr = localTime.split(" ");
  arr[0] = arr[0][0] == 0 ? arr[0].slice(1) : arr[0]; //Converting HH to H
  arr[1] = arr[1].toUpperCase(); //Converting am/pm to upper case
  return arr.join(" ");
}

export const fetchFreeCardsLeftCount = () => {
  const parentStore = require('../stores/parent-dashboard').Store;
  const { student } = parentStore.getState();
  const studentStore = require('../stores/student-dashboard').Store;
  const { student: studentFromStudentStore } = studentStore.getState();
  let studentId = student?.id || studentFromStudentStore?.id;
  const tieredOfferingData = JSON.parse(localStorage.getItem('tiered_offerings') || '{}');

  // setting default value of lp from tiered offering api
  let freeCardLeft = tieredOfferingData?.current_tiered_offering?.offerings?.lp || '0';

  if (hasAccessToFlutterDRS()) {
    const keyForCardsLeft = Object.keys(localStorage).find(key => key.includes(`flutter.${studentId}_free_cards_left`));
    if (keyForCardsLeft) {
      freeCardLeft = localStorage.getItem(keyForCardsLeft);
    }
  } else {
    freeCardLeft = sessionStorage.getItem(`${studentId}_free_cards_left`) || '0';
  }
  switch (freeCardLeft) {
    case UNLIMITED: {
      return 10000000;
    }
    case null: {
      return 0;
    }
    default: {
      let freeCardsLeftNum = JSON.parse(freeCardLeft);
      return typeof (freeCardsLeftNum) == "string" ? JSON.parse(freeCardsLeftNum) : freeCardsLeftNum;
    }
  }
}

export const fetchFreeLiveClassCount = () => {
  const Store = require('../stores/student-dashboard').Store;
  const { student } = Store.getState();
  if (hasAccessToFlutterDRS()) {
    const keyForLiveClassLeft = Object.keys(localStorage).find(key => key.includes(`flutter.${student?.id}_free_live_class_left`));
    return localStorage.getItem(keyForLiveClassLeft);
  }
  return sessionStorage.getItem(`${student?.id}_free_live_class_left`);
}

export const fetchFreeWsDownloadCount = () => {
  // possible values for ws count -> 0, 1, 2, unlimited
  return localStorage.getItem(`free_ws_download_left`);
}

export const getFreeCountAvailable = () => {
  const tabCode = getActiveTabCode();
  switch (tabCode) {
    case 'home':
    case 'game_zone':
    case 'printables':
    case 'curriculium': {
      return JSON.parse(fetchFreeCardsLeftCount())
    }
    case 'live_class': {
      return JSON.parse(fetchFreeLiveClassCount())
    }
    case 'printables': {
      return JSON.parse(fetchFreeWsDownloadCount())
    }
    default: {
      return JSON.parse(fetchFreeCardsLeftCount())
    }
  }
};

// set show pop up value in storage
export const setShowPopupInStorage = (value) => {
  if (value) {
    sessionStorage.setItem(SHOW_POPUP, value);
  }
}

// get show pop up value in storage
export const getShowPopupFromStorage = () => {
  return sessionStorage.getItem(SHOW_POPUP);
}

// remove show pop up value in storage
export const removeShowPopupFromStorage = () => {
  sessionStorage.removeItem(SHOW_POPUP);
}

export const isWorksheetsOrActivities = () => {
  const isDRS = isFreemiumDRSAssigned() || hasAccessToFlutterDRS();
  if (isDRS) {
    const drsActiveTab = getActiveTabCode();
    return (drsActiveTab == 'printables' ? 'Worksheets' : 'Activities');
  }
  else {
    const gamActiveTab = getHeaderVariationInStorage();
    return (gamActiveTab == 'printables' ? 'Worksheets' : 'Activities');
  }
}

export const addQueryParamToPath = (path, keyValueObj) => {
  if (!path) return '';

  Object.entries(keyValueObj).map(([key, value]) => {
    if (!path.includes(key) && value) {
      if (typeof value === 'object') {
        // If the value is an object (possibly nested), stringify it
        value = encodeURIComponent(JSON.stringify(value));
      }
      path += (path.indexOf('?') >= 0 ? "&" : '?') + key + "=" + value
    }
  });
  return path;
}

export const filterExtraParamsForLauncher = (data) => { //new
  let paramsObj = {};
  if (data) {
    Object.entries(data).map(([key, value]) => {
      if (!['hash', 'href', 'zoom_link'].includes(key) && value) {
        paramsObj[key] = value;
      }
    });
  }
  return paramsObj;
}

export const addUniqueParamsToPath = (path, paramsObj) => {
  const extraPathParams = paramsObj && Object.keys(paramsObj).length !== 0 ? paramsObj : getQueryParamsObj(window.location.href, true);

  if (extraPathParams) {
    for (const [key, value] of Object.entries(extraPathParams)) {
      if (typeof value === 'object' && value !== null) {
        // If the value is an object (possibly nested), stringify it
        const stringValue = JSON.stringify(value);
        if (!path.includes(key) && stringValue) {
          path += `&${encodeURIComponent(key)}=${encodeURIComponent(stringValue)}`
        }
      } else {
        if (!path.includes(key) && value) {
          path += `&${key}=${decodeEncodeURIComponent(value)}`
        }
      }
    }
  }
  return path;
};

export const decodeEncodeURIComponent = (value) => {
  return encodeURIComponent(decodeURIComponent(value));
}

export const hasSignedUpFromWs = () => {
  const signupPageUrl = getItemFromSessionStorage('signup_page_url') || '';
  // There can be 5 types of possible values when user sign ups from Worksheets pages -
  // 1. s/math-worksheets/identify-bigger-or-smaller
  // 2. s/ela-worksheets/find-the-word-look
  // 3. worksheets
  // 4. ela-worksheets
  // 5. math-worksheets

  if (signupPageUrl.includes('worksheets')) {
    setItemInLocalStorage('viaWsOnboarding', true);
    setItemInLocalStorage('showFilteredWsData', true);
    setItemInLocalStorage('defaultTabPrintables', true);
    return true;
  }
  else {
    return false;
  }
}

export const isDifferentDay = () => {
  const currentDate = new Date().toLocaleDateString();
  if (localStorage.getItem("currentDate") == currentDate) {
    return false;
  }
  localStorage.setItem("currentDate", currentDate);
  return true;
}

// set default tab printables in storage
export const setDefaultTabPrintablesInStorage = (value) => {
  if (value) {
    localStorage.setItem("defaultTabPrintables", value);
  }
}

// get default tab printables in storage
export const getDefaultTabPrintablesFromStorage = () => {
  return localStorage.getItem("defaultTabPrintables");
}

// remove default tab printables in storage
export const removeDefaultTabPrintablesFromStorage = () => {
  localStorage.removeItem("defaultTabPrintables");
}

export const fetchValidTillTimestamp = (startTime) => { // Returns time in milliseconds after adding 10 minutes in start time
  return parseInt(startTime) + (FREEMIUM_NO_BLOCKER_TIME_IN_MINUTE * 60000);
}

export const fetchDashboardType = () => {
  let dashboardType;
  if (hasAccessToTeacherFreemiumNoBlocker()) {
    dashboardType = 'noBlockerTimer';
  } else if (hasAccessToFlutterDRS()) {
    dashboardType = 'drsFlutter';
  } else if (isFreemiumDRSAssigned()) {
    dashboardType = 'drsNonFlutter';
  } else if (hasAccessToFreemium()) {
    dashboardType = 'ato';
  } else {
    dashboardType = 'gamification';
  }

  return dashboardType;
}

// download WS logic for all dashboards
export const canDownloadWs = () => {
  const Store = require('../stores/student-dashboard').Store;
  let { student, settings } = Store.getState();
  let dashboardType = fetchDashboardType();
  showWsCountText();

  switch (dashboardType) {
    case 'noBlockerTimer': {
      if (getItemFromLocalStorage(`no_blocker_timer_expired_${student.id}`)) {
        return false;
      }
      return true;
    }
    case 'gamification':
    case 'ato':
      return true;
    case 'drsFlutter':
    case 'drsNonFlutter': {
      if (settings?.current_tiered_offering?.offerings?.lp == UNLIMITED || Number(fetchFreeWsDownloadCount()) > 0 || (settings.is_classroom_student && settings.restriction_info?.selected_mode === "school")) {
        return true;
      }
      return false;
    }
    default:
      return true;
  }
}

// To show "You have x of y free worksheets left for today" text in WS Preview popup
export const showWsCountText = () => {
  const Store = require('../stores/student-dashboard').Store;
  let { settings } = Store.getState();
  let dashboardType = fetchDashboardType();
  let showText = true;

  switch (dashboardType) {
    case 'noBlockerTimer':
    case 'gamification':
    case 'ato':
      showText = false;
    case 'drsFlutter':
    case 'drsNonFlutter': {
      if (settings?.current_tiered_offering?.offerings?.lp == UNLIMITED || (settings.is_classroom_student && settings.restriction_info?.selected_mode === "school")) {
        showText = false;
      }
    }
  }
  localStorage.setItem('showWsCountText', showText);
}

export const isUserLoginChange = (type, value = true) => {
  const isLogin = 'isLogin';

  switch (type) {
    case 'set':
      setItemInLocalStorage(isLogin, value);
      break;
    case 'get':
      return getItemFromLocalStorage('isLogin');
    case 'remove':
      deleteItemFromLocalStorage(isLogin);
      break;
  }
}

// returns the highest grade code of the user
export const fetchHighestUserGrade = (studentId) => {
  let userGrade = localStorage.getItem(`${studentId}_grade`); // it is from profile api
  let userGradeFromHome = fetchHighestGradeCodeFromHomeApi(studentId); // it is from home api
  return userGrade ? userGrade : userGradeFromHome;
}

export const setHighestGradeInLSFromHome = (student = {}) => {
  const studentId = student.id;
  const allGrades = student.subject_wise_grade;
  const mathGradeNum = allGrades && gradeMappingForCompare[allGrades['Math Grade']];
  const elaGradeNum = allGrades && gradeMappingForCompare[allGrades['Ela Grade']];
  if (mathGradeNum > elaGradeNum) {
    allGrades && localStorage.setItem(`${studentId}_grade_from_home`, allGrades['Math Grade']);
  }
  else {
    allGrades && localStorage.setItem(`${studentId}_grade_from_home`, allGrades['Ela Grade']);
  }
}

export const fetchHighestGradeCodeFromHomeApi = (studentId) => {
  return localStorage.getItem(`${studentId}_grade_from_home`) || '';
}

export const setHighestGradeInLocalStorage = (studentId, courses = []) => {
  const highestGrade = highestGradeCode(courses);
  studentId && localStorage.setItem(`${studentId}_grade`, highestGrade);
}

/// Check shool hours for b2b and ptl user
export const isSchoolHoursAvailable = () => {
  const Store = require('../stores/student-dashboard').Store;
  const { settings } = Store.getState();
  if (settings && settings.is_classroom_student && settings.restriction_info.selected_mode === 'school') {
    return true;
  }
  else {
    return false;
  }
}

export function canShowCatexMigrationScreenValue(param, value) {
  let id = 'can_show_catex_migration_screen' + fetchStudentIdFromStore();
  let key = param.toLowerCase();
  switch (key) {
    case 'get':
      return sessionStorage.getItem(id);
    case 'set':
      sessionStorage.setItem(id, value.toString())
      break;
    case 'remove':
      sessionStorage.removeItem(id);
      break;
    default:
      break;
  }
}

export const removeFlutterStorageKeys = () => {
  Object.keys(sessionStorage).forEach(key => {
    if (key.includes('flutter.')) {
      sessionStorage.removeItem(key);
    }
  });
  Object.keys(localStorage).forEach(key => {
    if (key.includes('flutter.') && !(key.includes('flutter.tab_switch_') || key.includes('flutter.hasUserLoggedInFirstTime_'))) {
      localStorage.removeItem(key);
    }
  });
}

export const getUserPreferredLanguage = () => {
  let lang = localStorage.getItem('user_preferred_language');
  if (!lang) {
    const Store = require('../stores/parent-dashboard').Store;
    const { preferred_language } = Store.getState().currentUser;
    lang = preferred_language;
  }
  return lang;
}

export const getMetaSessionUserId = () => {
  const cookieObjString = getCookie('game_playable_url');
  if (cookieObjString) {
    const cookieObj = JSON.parse(cookieObjString);
    return cookieObj['meta_user_session_id'];
  }
  return '';
}

export const contentTypeCategories = [
  'Book',
  'Activities',
  'Exploratory Games',
  'Multiplayer Games'
];

export const getMobilePortrait = () => {
  return useMediaQuery({ maxWidth: breakpoints.sm - 1, orientation: 'portrait' });
}

// this func returns 12 am of monday of week in user's timezone converted to utc
export const getStartingMondayOfWeekDateTimeinUtc = () => {
  let currentDate = new Date();

  const daysAfterMonday = (currentDate.getDay() - 1 + 7) % 7; // Using mod for Sunday

  let mondayUtc = new Date(currentDate);
  mondayUtc.setDate(currentDate.getDate() - daysAfterMonday);
  mondayUtc.setHours(0, 0, 0, 0);

  return mondayUtc.toISOString();
}
export const isOnboardingIncomplete = () => {
  const Store = require('../stores/parent-dashboard').Store;
  const { onboardingIncomplete } = Store.getState().settings;
  if (onboardingIncomplete) {
    return true;
  }
  return false;
}

export const isPurchasePage = () => {
  const currentURL = window.location.href;
  return currentURL.includes(PURCHASE_PATH);
}

export const setActiveTabForFlutter = (tabcode, studentId) => {
  if (studentId) {
    setItemInLocalStorage(`flutter.activeTabCode_${getSanitizedUUID(studentId)}`, tabcode);
  }
}

export const getActiveTabForFlutter = (studentId) => {
  if(!studentId) {
    const userStudent = localStorage.getItem('user_student');
    studentId = userStudent ? JSON.parse(userStudent)?.id : null;
  }
  return (studentId && getItemFromLocalStorage(`flutter.activeTabCode_${getSanitizedUUID(studentId)}`)) || "";
}

export const getSanitizedUUID = (uuid) => {
  return uuid.replace("-", "").toUpperCase();
}

export const getItemFromLocalStorageWithExpiryCheck = (key) => {
  const itemStr = localStorage.getItem(key);
  // if the item doesn't exist, return null
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();
  // compare the expiry time of the item with the current time
  if (now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
    localStorage.removeItem(key);
    return null;
  }
  return item.value;
}

export const isDevicePortrait = () => {
  const isPortrait = window.matchMedia("(orientation: portrait)").matches;
  if (isPortrait) {
    return true;
  }
  else {
    return false;
  }
}

export const getCoqAnswers = () => {
  const coqAnswersFromReact = getItemFromSessionStorage('coq_answers');
  const coqAnswersFromFlutter = JSON.parse(localStorage.getItem('flutter.coq_answers'));
  return (coqAnswersFromReact || coqAnswersFromFlutter);
}

export const saveLocalStorageForFlutter = (key, data, expiryTime = 0) => {
  const lsObject = {
    "expiryTimeSecs": expiryTime,
    "populateTime": new Date().valueOf(),
    "data": data,
    "key": key
  }
  localStorage.setItem(key, JSON.stringify(JSON.stringify(lsObject)));
}
// Returns game engine of the game
// Returns engine of the game
export const getGameEngine = (gameMap, item) => {
  if (!gameMap || !item) {
    return;
  }
  let engine = ''
  let playableType = findPlayableType(item.entity_type);
  if (playableType == WORKSHEET) {
    engine = WORKSHEET;
  }
  else {
    let gameProps = getGameProperties(gameMap, item);
    engine = gameProps && gameProps.engine || '';
  }

  return engine;
}

export const getGradeFromOnboardingData = () => {
  const onboardingData = getItemFromLocalStorage('splashverse-onboarding');
  const grade = onboardingData && onboardingData.selectedGrade;
  return grade;
}

export const setLiveClassTabActiveAfterPurchase = () => {
  const applicationContext = new ApplicationContext();
  applicationContext.platformSettings.setDefaultTab(tabNames.liveClass);
  setCookieWithAge(TAB_CODE, LIVE_CLASS);
  saveHeaderVariationInStorage(TypesOfModes['LiveClass']);
  sessionStorage.setItem('activeTabCode', LIVE_CLASS);
}
export const getTitleText = (url) => {
  switch (url) {
    case 'math':
      return 'Explore 8,000+ Math and Reading Skills for Pre-K to Grade 5 | SplashLearn';
    case 'reading':
      return 'Explore 2,000+ Reading Skills | SplashLearn ';
    case 'child-profile':
      return "View Your Child's Progress | SplashLearn";
    case 'settings':
      return 'Account Settings | SplashLearn';
    case 'purchase':
      return 'Subscribe to SplashLearn | SplashLearn';
    case 'cg-listing':
      return 'Explore All Topics | SplashLearn';
    case 'mathfacts':
      return 'Play Math Facts | SplashLearn';
    case 'set-goal':
      return 'Set Weekly Schedule | SplashLearn';
    case 'student-form':
      return 'Edit Child Profile | SplashLearn';
    default:
      return 'SplashLearn - Fun Math and Reading Practice for Grades K-5';
  }
}

export const changeTitleOnHash = (isHref = false) => {
  let url = isHref ? window.location.pathname.split(/[?/]/)[1] : window.location.hash.split(/[?/]/)[1];
  document.title = getTitleText(url);
}

// Returns game object
export const getGameProperties = (gameMap, item) => {
  if (!gameMap || !item) {
    return;
  }
  return gameMap.get(item.game_id) && gameMap.get(item.game_id);
}

// Returns code of the game
export const getGameCode = (gameMap, item) => {
  if (!gameMap || !item) {
    return;
  }
  let gameCode = ''
  let playableType = findPlayableType(item.entity_type);
  if (playableType == WORKSHEET) {
    gameCode = WORKSHEET;
  }
  else {
    let gameProps = getGameProperties(gameMap, item);
    gameCode = gameProps && gameProps.code || '';
  }

  return gameCode;
}

// Returns name of the game
export const getGameName = (gameMap, item) => {
  if (!gameMap || !item) {
    return;
  }
  let gameName = ''
  let playableType = findPlayableType(item.entity_type);
  if (playableType == WORKSHEET) {
    gameName = WORKSHEET;
  }
  else {
    let gameProps = getGameProperties(gameMap, item);
    gameName = gameProps && gameProps.title || '';
  }

  return gameName;
}


// Returns playable clicked event properties
export const getPlayableClickedEventProps = (gameMap, item) => {
  let props = {};

  if (!gameMap || !item) {
    return props;
  }

  props["Game Name"] = getGameName(gameMap, item),
    props["Game Code"] = getGameCode(gameMap, item);
  props["Game Engine"] = getGameEngine(gameMap, item);
  return props;

}

/// Removes <> from playable name
export const parsePlayableName = (name) => {
  if (!name) {
    return ""
  }
  return name.replace(/<\/?[^>]+(>|$)/g, "");
}

const BOOKS_CONTENT_CODES = ["lr1", "lr", "db", "oddbods_books", "br", "ob", "bed_time_story"];

export const getContentType = (item) => {
  if (!item) {
    return "";
  }

  if (item.content_group_code && BOOKS_CONTENT_CODES.includes(item.content_group_code)) {
    return playableTypes.book;
  }
  else return findPlayableType(item.entity_type);
}

export const toSnakeCase = (input) => {
  if (_.isArray(input)) {
    return input.map(item => toSnakeCase(item));
  } else if (_.isObject(input)) {
    return _.transform(input, (result, value, key) => {
      const snakeCaseKey = _.snakeCase(key);
      if (_.isObject(value) || _.isArray(value)) {
        result[snakeCaseKey] = toSnakeCase(value);
      } else {
        result[snakeCaseKey] = value;
      }
    });
  } else {
    return input;
  }
}
export const getStudentId = () => {
  const Store = require('../stores/student-dashboard').Store;
  const studentId = (Store.getState().student.id) || sessionStorage.getItem('student_id');
  return (studentId);
}

export function setDashboardDirty() {
  let current_timestamp = new Date();
  try {
    localStorage.setItem(`dashboard_dirty_${getStudentId()}_timestamp`, current_timestamp);
  } catch (e) {
    let errorInfo = {
      extraMsg: 'Quota exceeded!',
    };
    if (e == QUOTA_EXCEEDED_ERR) {
      sendErrorToSentry(e, errorInfo);
      localStorage.clear();
      sessionStorage.clear();
    }
  }
}

export const checkIfElementExist = (id) => {
  const ele = document.getElementById(id);
  if(ele) {
    return true;
  }
  return false;
}

export const isOldPlanTierAssigned = () =>{
  let planCode = localStorage.getItem('plan_code');
  if(!planCode){
    return false;
  }
  return OldPurchasePagePlanCodes.includes(planCode);
}

export const getBaseParams = ({ settings = {}, courses = [], mathGrade, elaGrade, grade = "", signupFlow = "" }) => {
  if(isOnboardingIncomplete() && (grade == "" || courses.length == 0)) {
      grade = getGradeFromOnboardingData();
      mathGrade = grade;
      elaGrade = grade;
  }
  else {
      grade = grade || highestGradeCode(courses);
  }
  const baseEventProperties = {
      mode: getMode(settings),
      signupFlow: signupFlow != "" ? signupFlow : getSignupFlow(settings),
      platform: getDeviceType(),
      userType: getUserType(settings),
      ...(grade && { grade:  grade }),
      ...(mathGrade && { mathGrade: mathGrade }),
      ...(elaGrade && { elaGrade: elaGrade })
  }
  return baseEventProperties;
}

export const getMode = (settingsData = {}) => {
  let mode = 'b2chome'; // for B2C users

  // for b2b and ptl
  if(settingsData && settingsData.is_classroom_student) {
      mode = settingsData?.restriction_info?.selected_mode
  }
  return mode;
}

export const getSignupFlow = (settingsData = {}) => {
  if(settingsData?.user_signup_flow) {
      return settingsData.user_signup_flow;
  }
  else if(settingsData?.via_teacher_student_center) {
      return "student_experience";
  }
  if(settingsData?.is_classroom_student) {
      return "classcode";
  }
  return getUserSignupFlow();
}

export const getUserType = (settings) => {
  if(settings && settings.logged_in_guardian_type == "teacher") {
    return "Student";
  }
  else {
    return "Parent";
  }
}

export const getMemoryInfo = () => {
  const memoryInfo = window.performance?.memory;
  if (!memoryInfo) {
    return;
  }
  const totalMemoryMB = (memoryInfo?.totalJSHeapSize / 1048576).toFixed(2);
  const usedMemoryMB = (memoryInfo?.usedJSHeapSize / 1048576).toFixed(2);
  const memoryLimitMB = (memoryInfo?.jsHeapSizeLimit / 1048576).toFixed(2);
  let memoryUsagePercentage = 0;
  try {
    memoryUsagePercentage = (usedMemoryMB / memoryLimitMB) * 100;
  } catch (error) {
    console.error(error);
  }
  return {
    'Total Memory': totalMemoryMB,
    'Used Memory':  usedMemoryMB,
    'Memory Limit': memoryLimitMB,
    'Memory Usage Percentage': memoryUsagePercentage.toFixed(2)
  }
};

export const getWebAudioEnabled = (isEnabled) => {
  return isGameHeaderV1Assigned() ? !isEnabled: isEnabled;
}

export const defaultAvtarUrl = () => {
  const cdnAssetUrl = getCDNAssetURL();
  const defaultPath = `${cdnAssetUrl}/screenshot_avatars/12345.png`;
  // Default avtar url
  return defaultPath;
}

// Utility function to get CDN URL
export const getAvtarCdnUrl = async (userId) => {
  // If no userId is provided or userId is null, return the Default avtar URL
  if (!userId || userId == null) {
    return defaultAvtarUrl();
  }

  try {
    const userIdInUUID = convertToUUIDFormat(userId);
    let response = await fetchAvatarUrl({ 'userId': userIdInUUID });
    if (response?.userProfile?.gamificationProfile?.avatarUrl) {
      return response?.userProfile?.gamificationProfile?.avatarUrl;
    }
    return defaultAvtarUrl();
  } catch (error) {
    console.error(`Failed to fetch CDN URL for student avtar "${userId}":`, error);
    return defaultAvtarUrl(); // Return the default avtar URL as a fallback
  }
};

export const generateUUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const random = Math.random() * 16 | 0;
    const value = c === 'x' ? random : (random & 0x3 | 0x8);
    return value.toString(16);
  });
};

export const isCamelCase  = (str) => {
  return /^[a-z]+([A-Z][a-z]*)*$/.test(str);
}

export const camelToTitleCase = (key) => {
  if (isCamelCase(key)) {
    return key
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, (str) => str.toUpperCase())
      .trim();
  }
  return key;
}

export const handleAddFromChildProfile = () =>{
  const { settings, students, student } = ParentStore.getState();
  var studentId = null, hashRoute= null;
  const ELAEnabled=getABTestValue('Parent','Ela') === "ELA" ? true : false;
  if(settings.hasBeenSubscribed){
    if(!settings.childAdded){
      studentId = student.id;
    }
  }
  if (settings.creditCount > 0 || studentId) {
    hashRoute = '/student-form/' + (studentId || 'add') + '/src=settings';
  } else {
    if (ELAEnabled) {
      hashRoute = '/grade-select'; 
    } else {
      hashRoute = '/purchase/settings';  
    }
    purchasePageEventData = {
      source: 'Add Child Page',
      'Child Count': students && students.length,
    };
  }
  location.hash=hashRoute;
}

export const isAdaptiveAssigned = () =>{
  const adaptiveAssigned = getABTestValue('Parent','Dashboard_Adaptive_Algo_V1');
  if(adaptiveAssigned && adaptiveAssigned === "Variant"){
    return true;
  }
  return false;
}

export const getValueFromFlutterLocalStorage = (dynamicKey, targetKey) => {
  try {
      // Find the full key dynamically
      const keys = Object.keys(localStorage);
      const matchingKey = keys.find(key => key.includes(dynamicKey));

      if (!matchingKey) {
          console.warn(`No key matching "${dynamicKey}" found in localStorage.`);
          return null;
      }

      // Retrieve and parse the value
      const item = getItemFromLocalStorage(matchingKey);
      const parsedData = JSON.parse(item).data;

      // If targetKey is provided, return specific data from the object
      if (targetKey) {
          return parsedData?.[targetKey] || null;
      }

      // Return the entire parsed object if no specific key is requested
      return parsedData;
  } catch (error) {
      console.error("Error handling localStorage data:", error);
      return null;
  }
}

export const getUserPersonaType = () => {
  const parentId  = JSON.parse(localStorage.getItem('user_student'))?.parent_id;
  if(parentId) {
    return 'ptl';
  }
  return 'class only';
}

export  const getABTestDataFromLS = (parentId, teacherId) => {
  const getABTestData = (id) => id && getValueFromFlutterLocalStorage(`flutter.ab_test_${id}`, 'assigned_ab_tests');

  try {
    const parentData = getABTestData(parentId);
    const teacherData = getABTestData(teacherId);
    
    const combinedData = { ...parentData, ...teacherData };
    
    return Object.keys(combinedData).length 
      ? JSON.stringify(combinedData) 
      : (console.error('No AB test data found for teacher or parent!'), null);
  } catch (error) {
    console.error('Error while combining AB test data:', error);
    return null;
  }
};


export const canPlayPostParams = () => {
  const student  = JSON.parse(localStorage.getItem('user_student'));
  const parentId  = student?.parent_id;
  const teacherId  = student?.teacher_id;
  let params = {
    ab_tests: getABTestDataFromLS(parentId, teacherId),
    klass_id: student?.klass_id,
    offering_type: 'lp',
    timezone: student?.time_zone || "",
    user_id: student?.id,
  };
  return params;
}

export const clearLocalStorageKeysForPTLSignup = () => {
  localStorage.removeItem("referrerCodeForCommonLink");
  localStorage.removeItem("referralTypeForCommonLink");
  localStorage.removeItem("linkedStudentCount");
  localStorage.removeItem("mathGrade");
  localStorage.removeItem("invitationSource");
  localStorage.removeItem("referrerPage");
}

export const logTurnstileValidationFailure = ({ event, props }) => {
  window.trackEventsForGuests(event, 
    { 
      ... props,
      "custom_user_type": "unverified_user"
    }, 
    { send_datadump: true, send_mixpanel: true, send_clevertap: false });
}

// token used for client side validation
export const getTurnstileSecurityToken = () => {
  let turnstileSecurityToken = null;
  // window.turnstile_enabled_features is being set on window when user lands on sign-up page.
  // for logged-in pages, this is being set using `turnstile_enabled_features` cookie.
  if (turnstileEnabled()) {
    if (window.turnstile) {
      turnstileSecurityToken = window.turnstile.getResponse();

      if(!turnstileSecurityToken)
        logTurnstileValidationFailure({ 
          event: "Validation failed using turnstile",
          props: {
            validatedUserType: "parent",
            error_code: window.turnstile_error_code 
          }
        });

    } else {

      logTurnstileValidationFailure({ 
        event: "Turnstile script not loaded",
        props: { validatedUserType: "parent" }
      });
    }
  }

  return turnstileSecurityToken;
}

export const turnstileEnabled = () => {
  return window.turnstile_enabled_features?.parent_and_teacher_signup;
}

// this function returns true for US or CA country 
export const isUSOrCACountry = () => {
  const tieredOfferingData = JSON.parse(localStorage.getItem('tiered_offerings') || '{}');
  const countryCode  = tieredOfferingData?.settings?.country_code;
  return ['US', 'CA'].includes(countryCode);
}

// this function returns true for AU or UK country 
export const isAUOrUKCountry = () => {
  const tieredOfferingData = JSON.parse(localStorage.getItem('tiered_offerings') || '{}');
  const countryCode  = tieredOfferingData?.settings?.country_code;
  return ['AU', 'UK'].includes(countryCode);
}

export const PREPAID_CARD_ERROR_MSG = "Prepaid cards are not allowed. Please try again with a credit or debit card!";

export const handlePrepaidCardRejection = (params) => {
  const { cardData, setErrorFunc, getRenderedElementFunc, analyticsParams = {} } = params;
  
  // Check if card is prepaid
  const isPrepaid = (cardData?.card?.funding === 'prepaid') || (cardData?.funding === 'prepaid');
  
  if (isPrepaid) {
    const isNewStripePaymentElementEnabled = toShowStripePaymentElement() || toShowStripePaymentElementWithPaypal();
    // Set error message
    setErrorFunc(PREPAID_CARD_ERROR_MSG);    
    sendEventUsingAvo({
      methodName: 'paymentFormError', 
      params: {
        errorCode: 'prepaid_card_not_accepted',
        paymentElementsRendered: getRenderedElementFunc ? getRenderedElementFunc() : 'Payment Element',
        errorMessage: PREPAID_CARD_ERROR_MSG,
        errorStep: isNewStripePaymentElementEnabled ? 'confirm_setup_failed' : 'subscribe_product_failed',
        errorMessageFromApi: PREPAID_CARD_ERROR_MSG,
        ...analyticsParams
      }
    });
    return true; // Prepaid card was detected and handled
  }
  return false; // Not a prepaid card
};
